import {Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { UploadDownloadService } from '../file-upload/upload-download.service';
import { ShareDataService } from 'src/providers/sharedata.service';
import { DialogComponent } from 'src/app/dialog/dialog.component';
import { MatDialog } from '@angular/material/dialog';


@Component({
  selector: 'app-logo',
  templateUrl: './logo.component.html',
  styleUrls: ['./logo.component.scss']
})
export class LogoComponent implements OnInit {
  loading: boolean = false;
  loader: string;
  fileName: string;
  selectedFile: FormData;
    DateNow: string;
  
  constructor(public uploadService: UploadDownloadService, public router: Router, public share: ShareDataService,public dialog: MatDialog) { }
  

  ngOnInit(): void {
    this.date();
  }

  confirmation(title: string) {
    const dialogRef = this.dialog.open(DialogComponent);
    dialogRef.componentInstance.confirmation(title);
    dialogRef.afterClosed().subscribe(result => {
        if (result === 'Ok') {
            this.dialog.closeAll();
        } else {
            return;
        }
    });
  }
  date(): void { this.DateNow = `?${Date.now()}`; }

}
